/** Route guard — redirects to login if not authenticated, syncs backend user lazily. */

import { useEffect, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { firebaseUser, user, loading, syncing, syncFailed, syncUser } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    // Firebase user exists but backend user not yet loaded — sync now
    if (firebaseUser && !user && !syncing && !syncFailed) {
      syncUser();
    }
  }, [firebaseUser, user, syncing, syncFailed, syncUser]);

  // Still initializing Firebase, or syncing backend user, or pending sync start
  const pendingSync = !!firebaseUser && !user && !syncFailed;
  if (loading || syncing || pendingSync) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!firebaseUser || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
